// @flow
import {Tag} from 'docs/util';

import type {MarkdocTagRegistration} from 'docs/markdoc';
import {IDENTIFIER_MAP} from './identifierMap';

export const Identifier: MarkdocTagRegistration = {
  tag: 'identifier',
  component: 'Identifier',
  selfClosing: true,
  description:
    'Render a fake ID with a tooltip for a Stripe resource inside a CodeBlock, e.g. {{CUSTOMER_ID}}.',
  attributes: {
    type: {
      type: String,
      required: true,
      matches: Object.keys(IDENTIFIER_MAP),
      description:
        'The Stripe resource to generate an identifier for. Can be "customer", "paymentMethod", "price", "product", "connectedAccount", or "location".',
    },
    value: {
      type: String,
      required: false,
      description:
        'A value to use before defaulting to the default fake ID -- will default to the fake resource ID if the value is null.',
    },
    quoteType: {
      type: String,
      required: false,
      matches: ['none', 'single', 'double'],
      description:
        "By default, the identifier tag will wrap the contents in the quote type (double or single) based on our style guide for the programming language of the code snippet. Pass in a quoteType to override this ('none, 'double', 'single').",
    },
  },
  render(node, config) {
    const attributes = node.renderAttributes(this.attributes, config);
    const type: string = IDENTIFIER_MAP[(attributes.type: any)]?.id;
    // HACK: The value is needed to be set explicitly as a React prop
    // since this is looked at when the snippet is copied.
    // See renderCode.js for more.
    attributes.value = attributes.value || type || '{{RESOURCE_ID}}';
    attributes.lang = String(config.variables['$$CodeBlock:language']);
    return new Tag(this.tag, attributes);
  },
};
